import { render, staticRenderFns } from "./VkBtn.vue?vue&type=template&id=34ef2fb6&"
import script from "./VkBtn.vue?vue&type=script&lang=js&"
export * from "./VkBtn.vue?vue&type=script&lang=js&"
import style0 from "./VkBtn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports